export default __webpack_public_path__ + "static/media/Ingar_Sicune_CamTransicion_Edificio002.1627c4a6.7886a24f.mp4";